export default __webpack_public_path__ + "static/media/juba.948a92ee.jpg";